import ModuleData from '../../../types/ModuleData'

const getDragType = (module: ModuleData | undefined): string => {
  switch (module?.type) {
    case 'SingularModule':
      return `module-singular-${module.id}`
    case 'VariableModule':
      return 'module'
    case 'Service':
      return 'service'
    default:
      return 'unknown'
  }
}

export default getDragType
